module.exports = __webpack_public_path__ + "mainassets/img/logo-header-2x.b8c07b2b.png";